var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"contain":"","height":"18px","width":"18px","src":require("@/assets/google_logo.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }